// ProfileLoader.tsx
import React, { useEffect, useState } from "react";
import { useAppDispatch } from "./redux/HooksRedux";
// import { getUserProfileAction } from './redux/User/userActions';
import { toast } from "react-toastify";
import { RouterProvider } from "react-router-dom";
import { router } from "./Routes";
import { getCookie } from "utils/cookieUtils";
import { ACCESS_TOKEN } from "utils/enums/misc";

const ProfileLoader: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  //   const getUserProfile = async () => {
  //     try {
  //       setIsLoading(true);
  //       await dispatch(getUserProfileAction());
  //     } catch (error: any) {
  //       console.log('Failed to get user profile', error);
  //       toast.error(error.response.data.message);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   useEffect(() => {
  //     if (getCookie(ACCESS_TOKEN)) {
  //       getUserProfile();
  //     }
  //   }, []);

  if (isLoading) {
    return null;
  } else {
    return <RouterProvider router={router} />;
  }
};

export default ProfileLoader;
